import { useEffect } from "react";
import useUser from "../Shared/UserProvider/useUser";
import { useExternalScript } from "./script.helper";
import { Link } from "react-router-dom-v5-compat";
import { Icon } from "semantic-ui-react";
import useFeature from "../Shared/FeatureProvider/useFeature";
import useCanAccessHelp from "./hooks/useCanAccessHelp";

export const HelpLink = ({style= undefined}) => {
    
  const isEnabled = useCanAccessHelp();
  //Temporarly disable
  if(!isEnabled) {
    return null;
  }
    return (
      <>
        /
          <Link target="_blank" to="/help" className="btn btn-primary" style={style}><Icon name="help circle" /></Link>
        </>
    );
};